import React from "preact/compat";
import { BooksItemProps } from './bookItem.type';
import { AffLink } from "../../../💎Atoms/AffLink/AffLink";
import { currencyFormatter } from "../../../../helper/currencyFormatter";
import { translation } from "../../../../locales/en/translation";

export const BooksItem: React.FunctionComponent<BooksItemProps> = ({
    className,
    site,
    sortedComparisonList,
    wager,
    odds
}) => {
    const partnerSelected = sortedComparisonList?.sportsbookVm;

    const brand = partnerSelected.sportsbookLogo ? partnerSelected.sportsbookLogo.replace("https://img.covers.com/betting/sportsbooks/bg-logos/", "").replace("_bg.svg","") : "";
    // 

    return (
        <div className={`partner-item ${site}-partner d-flex justify-content-lg-around align-items-stretch rounded w-100 border mb-1 mb-lg-2 ${className ? className : ''}`}>
            <div className={`col-3 p-0 position-relative partner-logo rounded-start d-flex align-items-center justify-content-center overflow-hidden bg-sb-${brand}`} style={{height: '50px'}}>
                <img width="auto" height="40" src={partnerSelected?.sportsbookLogo} />
                {/* {partnerSelected.providerBookId !== null && partnerSelected.providerBookId !== '' ? 
                    <span className="mat-icon-quick-icon-corner position-absolute bottom-0 end-0"></span>
                : ""} */}
            </div>
            <div className="col-9 py-2 ps-3 pe-2 d-flex justify-content-between align-items-center">
                <div className={`col-4 partner-odds text-start ${site === 'covers' ? 'fs-8' : 'fs-9'}`}>
                    <div className="p-0 fw-normal fs-8">
                        {wager ?
                            currencyFormatter.format(wager)
                        : odds ?
                            odds
                        : <span className="d-inline-block me-2">-</span> }
                    </div>
                </div>
                <div className={`col-4 partner-wins ${wager && wager > 0 ? 'text-start' : 'text-start'}`}>
                    {(wager && wager > 0 || odds) && partnerSelected?.sportsbookClickout ?
                        <span className="p-0 fw-normal fs-8 d-flex align-items-center">
                                {wager ? 
                                    currencyFormatter.format(sortedComparisonList.toWin)
                                : 
                                    currencyFormatter.format(sortedComparisonList.toWin)
                                }
                                {/* {currencyFormatter.format(calculateProfit(wager, calculatePayout(wager, selectedItemBet?.oddsDecimal)))} */}
                        </span>
                    : <span className="p-0 fw-normal fs-8">-</span> }
                    
                </div>
                <div className="col-4 partner-action text-start d-flex align-items-center">
                    {partnerSelected?.sportsbookClickout ?
                        <span className={`link-underline-primary p-0 fw-bold ${site === 'covers' ? 'fs-8' : 'fs-9'}`}>
                                {partnerSelected.providerBookId !== null && partnerSelected.providerBookId !== '' ? translation.books_list.cta : translation.books_list.cta}
                        </span>
                        // For later we can distinguish between the Bet now (translation.books_list.cta_quickBet) and the Sign up (translation.books_list.cta)
                    : 
                        <span className={`link-underline-primary p-0 fw-bold ${site === 'covers' ? 'fs-8' : 'fs-9'}`}>{partnerSelected.providerBookId !== null && partnerSelected.providerBookId !== '' ? translation.books_list.cta : translation.books_list.cta}</span>
                    }
                    {partnerSelected.providerBookId !== null && partnerSelected.providerBookId !== '' ? 
                        <span className="mat-icon-quick-icon ms-1"></span>
                    : ""}
                </div>
            </div>
        </div>
                
    )
};